﻿
angular.module('fliptoWeb').directive('ftTeamMember', function () {

    return {
        restrict: 'E',
        replace: true,
        templateUrl: 'team-member.html',
        scope: {
            slug: '@',
            chalk: '@',
            nameCard: '@',
            img: '@',
            name: '@',
            title: '@',
            story: '@',
            email: '@',
            twitter: '@',
            linkedin: '@'
        },
        link: function(scope, element, attrs) {
            var teamSection = angular.element(".team-section");
            var scroller = angular.element(".team-list-track");
            var list = scroller.find(".team-list");
            var img = element.find(".team-member-img");

            function toggleActive(value) {
                element.toggleClass("active", !!value);
                teamSection.toggleClass("is-list-view", !value);
                teamSection.toggleClass("is-member-view", !!value);
                if (!!value) {
                    var currentDistanceFromLeftOfScreenToLeftEdgeOfPhoto = img.offset().left;

                    var halfScreenSize = teamSection.width() / 2;
                    var halfElementSize = img.innerWidth() / 2;
                    var desiredDistanceFromLeftOfScreenToLeftEdgeOfPhoto = halfScreenSize - halfElementSize;

                    var amountToScrollLeft = currentDistanceFromLeftOfScreenToLeftEdgeOfPhoto - desiredDistanceFromLeftOfScreenToLeftEdgeOfPhoto;
                    var currentScroll = list.offset().left;
                    var newScroll = -1 * currentScroll + amountToScrollLeft;
                    scroller.animate({ scrollLeft: newScroll }, 600);
                }
            }

            img.on("click", function() {
                toggleActive(true);
                return false;
            });

            var close = element.find(".btn-close");
            close.on("click", function() {
                toggleActive(false);
                return false;
            });


            teamSection.on("click", function() {
                toggleActive(false);
                return false;
            });


            teamSection.on("click", "a", function(e) {
                e.stopPropagation();
            });


            scope.$on('$destroy', function() {
                img.off("click");
                close.off("click");
                teamSection.off("click");
            });
        }
    };
});